import { format as formatDate } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatTimestamp = ({
  timestamp,
  format,
}: {
  timestamp?: number;
  format: string;
}) => {
  if (!timestamp) return '';

  return formatDate(new Date(timestamp), format, { locale: ptBR });
};
